const initialState = {
  fetching: false,
};

export default function quizReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'QUIZ_FETCHING':
      return { ...currentState, fetching: true };
    case 'QUIZ_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
